'use client'

import {observer} from 'mobx-react'

import {
  CodeFormContainer,
  CodeSchema,
  LoginFormContainer,
  LoginSchema,
  useConfirmOtp,
  useLoginFormState,
  useRequestOtp,
} from '@/src/features/auth'
import {FormProvider} from '@/src/shared/modules/form'
import {useOAuthProviders} from '@/src/features/auth/model/use-oauth'
import React, {useEffect} from 'react'
import {useSearchParams} from 'next/navigation'
import {toast} from 'react-toastify'
import {LoginPageContent} from '@/src/(pages)/auth/login/types'
import {PageData} from '@/src/core/domain/entities/page/page-data'

export const LoginScreen: React.FC<PageData<LoginPageContent>> = observer(() => {
  const searchParams = useSearchParams()

  const formState = useLoginFormState()
  const {requestOtp, loading} = useRequestOtp()
  const {confirmOtp, isPending} = useConfirmOtp()
  const thirdPartyProviders = useOAuthProviders()

  useEffect(() => {
    if (searchParams.get('error')) {
      toast.error(searchParams.get('error'))
    }
  }, [])


  return (
    (formState.form === 'phone' && (
      <FormProvider key="phone-form" schema={LoginSchema}>
        <LoginFormContainer
          onNext={props => formState.changeForm('code', props)}
          onSubmitAction={requestOtp}
          thirdPartyProviders={thirdPartyProviders}
          loading={loading.state}
        />
      </FormProvider>
    )) ||
    (formState.options && (
      <FormProvider key="code-form" schema={CodeSchema}>
        <CodeFormContainer
          isPending={isPending}
          onConfirm={confirmOtp}
          {...formState.options}
          onBack={() => formState.changeForm('phone')}
        />
      </FormProvider>
    ))
  )
})
